'use strict'

import { io } from "socket.io-client"

let socket = io("https://touchh.herokuapp.com")

socket.on('connect', function () {

  let signup_btn = document.querySelector('.signup_btn')

  let nameField = document.querySelector('.signup_name_input')

  let genderField = document.querySelector('.signup_genger_input')

  let userNameField = document.querySelector('.signup_usernname_input')

  let passwordField = document.querySelector('.signup_password_input')

  let load = document.querySelector('.loadingAnimation')


  signup_btn.addEventListener('click', function (e) {
    e.preventDefault()

    if (nameField.value && userNameField.value && passwordField.value) {
      load.classList.remove('hide')
      document.querySelector('.signup_div').classList.add('opa')


      let newUser = {
        name: nameField.value,
        gender: `${genderField.value ? genderField.value : undefined}`,
        username: userNameField.value,
        password: passwordField.value,
        id: 0,
        chatHistory: [
          {
            sent: true,
            recieved: false,
            sender: "",
            message: ""
          }
        ],
        sentMessages: [
          ""
        ],
        receievedMessages: [
          ""
        ],
        logged_in: true,
        contactList: [
        ]
      }

      socket.emit("registerUser", newUser, 1680)

      socket.on("userRegistered", function (key) {
        setTimeout(function () {
          load.classList.add('hide')
          document.querySelector('.signup_div').classList.remove('opa')

          document.querySelector('.signup_btn').textContent = "Success"

          setTimeout(function () {
            document.location.reload('index.html')
          }, 1500)
        }, 3000)
      })

    }

    else {
      load.classList.add('hide')
      document.querySelector('.signup_div').classList.remove('opa')

      alert('Incorrect/Incomplete Details...')

    }

  })

})



//help modal
document.querySelector('.help_btn').addEventListener('click', function () {
  document.querySelector('.modal_help').classList.remove('hide')

  document.querySelector('.chatContainer').addEventListener('click', function () {
    document.querySelector('.modal_help').classList.add('hide')
  })
})



socket.on("status", function (data) {
  load = document.querySelector('.loadingAnimation')
  alert(data)
  load.classList.add('hide')
  document.querySelector('.signup_div').classList.remove('opa')
})